import { render } from "./TaxiInitiale.vue?vue&type=template&id=b5711bd8&scoped=true"
import script from "./TaxiInitiale.vue?vue&type=script&lang=js"
export * from "./TaxiInitiale.vue?vue&type=script&lang=js"

import "./TaxiInitiale.vue?vue&type=style&index=0&id=b5711bd8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5711bd8"]])

export default __exports__